"use strict";

/**
 * @fileoverview
 *
 * Simple version of what can be found in @flowio/session. This is a minimal copy because
 * @flowio/session depends on this (@flowio/request) module and we are avoiding a circular
 * dependency
 */
var get = require('lodash/get');

var storage = require('@flowio/storage');

function getSession() {
  /*
   * Use session storage first for temporary, marketing driven sessions that may need to be tracked
   * differently than permanent sessions on the same website.
   */
  return storage.session.get('session') || storage.local.get('session') || storage.memory.get('session');
}

function getSessionId() {
  return get(getSession(), 'id');
}

module.exports = getSessionId;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/request/lib/getSessionId.js
// module id = 689
// module chunks = 0 1